<section>    
    <div class="example-button-row">  
          
      <button mat-raised-button color="primary" (click)="openDialog()">Add Student</button>     
    
      
    </div>

    <div class="container">
      <div style="margin-top: 10px;">
        <div class="example-header">
          <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
          </mat-form-field>
        </div>
        <button mat-raised-button color="primary" (click)="exportArrayToExcel()">Export as Excel</button>
        <div class="example-container mat-elevation-z8">
          

          <table  id="ExampleMaterialTable" mat-table [dataSource]="dataSource" matSort>
        
            <!-- ID Column -->
            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.id}} </mat-cell>
            </ng-container>
        
            <!-- Progress Column -->
            <ng-container matColumnDef="Name">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.Name}} </mat-cell>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="Age">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Age </mat-header-cell>
              <mat-cell *matCellDef="let row"> {{row.Age}} </mat-cell>
            </ng-container>
        
            <!-- Color Column -->
            <ng-container matColumnDef="Address">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Address </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Address}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Gender">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Gender </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Gender}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Dateofbirth">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Dateofbirth </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Dateofbirth}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Classname">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Class </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Classname}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Sectionname">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Section </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Sectionname}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Religion">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Religion </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Religion}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Caste">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Caste </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Caste}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Mobile">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Mobile </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Mobile}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Admissionnum">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Admission no </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Admissionnum}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Fathername">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Father Name </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Fathername}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Fatheroccu">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Father Occupation </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Fatheroccu}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Mothername">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Mother Name </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Mothername}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Motheroccu">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Mother Occupation </mat-header-cell>
              <mat-cell *matCellDef="let row" > {{row.Motheroccu}} </mat-cell>
            </ng-container>



            <ng-container matColumnDef="Action">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
              <mat-cell *matCellDef="let row" > 
              <button mat-icon-button color="primary" (click)="editStudent(row)">
              <mat-icon>
                edit
              </mat-icon>
              </button>  
              <button mat-icon-button color="warn" (click)="deleteStudent(row)">
                <mat-icon>
                  delete
                </mat-icon>
                </button>  
              </mat-cell>
            </ng-container>
        
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;">
            </mat-row>
          </table>
        
          <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>
        
      </div>
    </div>
  </section>